import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

import samsungfireObesity from '@samsungfireObesity/router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import(/* webpackChunkName: "MainView" */ '../views/MainView.vue'),
    children: [
      ...samsungfireObesity,
      {
        path: 'no-auth',
        name: 'noAuth',
        component: () => import(/* webpackChunkName: "noAuth" */ '@/components/templates/noAuth.vue'),
      }
    ]
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;